var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.scenario &&
      _vm.scenario.quarter &&
      _vm.scenario.projectName &&
      _vm.scenario.name &&
      _vm.scenario.typeName
    )?_c('p',[_vm._v(" Models / "+_vm._s(_vm.scenario.quarter)+" / "+_vm._s(_vm.scenario.projectName)+" / "),_c('strong',[_vm._v(_vm._s(_vm.scenario.name))]),_vm._v(" ["+_vm._s(_vm.scenario.typeName)+"] ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }